import { Onderdeel } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Alerts, {
  onderdeel: Onderdeel.Alerts,
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Alerts,
    title: 'Alerts',
    url: '/app/crm/alerts/polisalerts',
    iconclass: 'fas fa-bell-on',
    target: '_top',
  }),
});
